import Grid from '@mui/material/Grid'

import PartnerDetail from './PartnerDetail'

export default function PartnerShow(props) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <PartnerDetail {...props} />
      </Grid>
    </Grid>
  )
}
